import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import theme from '../styles/theme';

const Bar = styled.div`
  position: fixed;
  left: 50%;
  bottom: calc(16px + env(safe-area-inset-bottom));
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #111827;
  color: #ffffff;
  padding: 12px 12px 12px 18px;
  border-radius: 999px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.35);
  font-size: 13px;
  max-width: calc(100vw - 32px);
`;

const RefreshButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 8px 16px;
  background: ${theme.gradient};
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
`;

// Shows a small "new version available" prompt when a waiting service
// worker is detected (see index.js's onUpdate callback), and reloads once
// the user opts in and the new service worker takes control.
export default function UpdateToast() {
  const [registration, setRegistration] = useState(null);
  const reloadingRef = useRef(false);

  useEffect(() => {
    const onUpdate = (e) => setRegistration(e.detail.registration);
    window.addEventListener('sw-update-available', onUpdate);

    const onControllerChange = () => {
      if (reloadingRef.current) return;
      reloadingRef.current = true;
      window.location.reload();
    };
    navigator.serviceWorker?.addEventListener('controllerchange', onControllerChange);

    return () => {
      window.removeEventListener('sw-update-available', onUpdate);
      navigator.serviceWorker?.removeEventListener('controllerchange', onControllerChange);
    };
  }, []);

  if (!registration?.waiting) return null;

  const onRefresh = () => {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  };

  return (
    <Bar>
      <span>A new version of MYC is available.</span>
      <RefreshButton type="button" onClick={onRefresh}>Refresh</RefreshButton>
    </Bar>
  );
}
